module.exports = __webpack_public_path__ + "static/media/anotacoes.7731e0b2.jpg";